
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs';
import { RequestPayU } from '../domain/request-pay-u';
import { RequestConsultaPartes } from '../domain/request-consulta-partes';

@Injectable({
  providedIn: 'root'
})
/**
 * En esta clase se encuentran los servicios relacionados a la consulta,
 * modificación y creación de partes desde y hacia SIGAMOS
 * @author Camilo Delgado
 * @version 2018-10-17
 */
export class ParteService {

  public paginaCargada: boolean= false;

  url : string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(public httpClient:HttpClient) {
    this.url = GLOBAL.URL_SIGAMOS + 'sicaParte';
  }

  /**
   * Obtengo partes filtrando por clasificación, línea, rango de precios y palabras clave. Junto con las imagenes
   * @author Camilo Delgado
   * @version Nov 19, 2018
   */
  public getDataParteConImagenes(partId:number, categoria: string[], lineId: number[], model:string, minPrice:number, maxPrice:number, keyWords:string, first:number, size:number, order:string): Observable<any>{
    let request : RequestConsultaPartes = new RequestConsultaPartes();
    
    request.partId = partId == null ? -1 : partId;
    request.categoria = categoria == null ? [] : categoria;
    request.lineId = lineId == null ? [] : lineId;
    request.modelo = model == null || model.trim() == '' ? '-1' : model.trim();
    request.precioMin = minPrice == null ? -1 : minPrice;
    request.precioMax = maxPrice == null ? -1 : maxPrice;
    request.keyWords = keyWords == null || keyWords.trim() == '' ? '%' : keyWords.trim();
    request.order = order == null || order.trim() == '' ? '1' : order.trim();
    request.first = first;
    request.pageSize = size;

    return this.httpClient.post(this.url+'/getDataParteConImagenes', request, this.httpOptions);
  }

  /**
   * @author Camilo Delgado
   * @version Nov 12, 2018
   */
  public getDataPartes(id:number, nombre:string, codigo:string, clasId:number, publicado:string, first:number, size:number): Observable<any>{
    id = id == null ? -1 : id;
    nombre = nombre == null || nombre.trim() === '' ? ' ' : nombre;
    codigo = codigo == null || codigo.trim() === '' ? ' ' : codigo;
    clasId = clasId == null ? -1 : clasId;
    publicado = publicado == null || publicado.trim() === '' ? ' ' : publicado;

    var params = id + '/' + nombre + '/' + codigo + '/' + clasId + '/' + publicado + '/' + first + '/' + size + '/';
    return this.httpClient.get(this.url+'/getDataParte/' + params,this.httpOptions);
  }

  public cambiarEstadoPartesSeleccionadas(listPartes: Array<number>, publicado:string, usuario:string): Observable<any> {
    return this.httpClient.post(this.url + '/cambiarEstadoPartes/', {'listPartId' : listPartes, 'publicadoNuevo' : publicado, 'usuario' : usuario});
  }

  public publicarPartesPorFiltros(listPartId:Array<number>, nombre:string, codigo:string, clasId:number, publicado:string, usuario:string): Observable<any>{
    nombre = nombre == null || nombre.trim() === '' ? ' ' : nombre;
    codigo = codigo == null || codigo.trim() === '' ? ' ' : codigo;
    clasId = clasId == null ? -1 : clasId;
    publicado = publicado == null || publicado.trim() === '' ? ' ' : publicado;
    var params = {
      'listPartId' : listPartId, 'codigo': codigo, 'nombre' : nombre, 'clcoId' : clasId, 'publicadoActual' : publicado, 
      'publicadoNuevo' : GLOBAL.SI, 'usuario' : usuario
    };
    return this.cambiarEstadoPartePorFiltros(params);
  }

  public ocultarPartesPorFiltros(listPartId:Array<number>, nombre:string, codigo:string, clasId:number, publicado:string, usuario:string): Observable<any>{
    nombre = nombre == null || nombre.trim() === '' ? ' ' : nombre;
    codigo = codigo == null || codigo.trim() === '' ? ' ' : codigo;
    clasId = clasId == null ? -1 : clasId;
    publicado = publicado == null || publicado.trim() === '' ? ' ' : publicado;
    var params = {
      'listPartId' : listPartId, 'codigo': codigo, 'nombre' : nombre, 'clcoId' : clasId, 'publicadoActual' : publicado, 
      'publicadoNuevo' : GLOBAL.NO, 'usuario' : usuario
    };
    return this.cambiarEstadoPartePorFiltros(params);
  }

  private cambiarEstadoPartePorFiltros(params:any) : Observable<any> {
    return this.httpClient.post(this.url+'/cambiarEstadoPartePorFiltros/', params,this.httpOptions);
  }

  public getPartesByListId(ids:number[]):Observable<any>{
    return this.httpClient.post(this.url+'/getPartesByListId/',ids,this.httpOptions);
  }
}
